import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadioEmpty = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 3.75,
		y: 3.75,
		width: 16.5,
		height: 16.5,
		rx: 8.25,
		stroke: "#333333",
		strokeWidth: 1.5
	})
});
export default SvgRadioEmpty;
